export default __webpack_public_path__ + "static/media/Path3415.e9987140.svg";